import _taggedTemplateLiteral from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { API, graphqlOperation } from 'aws-amplify';
import gql from 'graphql-tag';
import handleApiResponse from './handleApiResponse';
const getGroups = async type => {
  const query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getGroups($type: String!) {\n      getGroups(type: $type) {\n        id\n        providerId\n        name\n        color\n        counter\n      }\n    }\n  "])));
  return handleApiResponse(API.graphql(graphqlOperation(query, {
    type
  })));
};
const getMembershipGroups = () => getGroups('membership');

// Create / Update
const saveGroupApiRequest = async (name, type, color, id) => {
  const mutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation saveGroup($name: String!, $type: String!, $color: String!, $id: Int) {\n      saveGroup(name: $name, type: $type, color: $color, id: $id) {\n        success\n        id\n        message\n      }\n    }\n  "])));
  return handleApiResponse(API.graphql(graphqlOperation(mutation, {
    name,
    type,
    color,
    id
  })));
};
const deleteGroupApiRequest = async id => {
  const mutation = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    mutation deleteGroup($id: Int!) {\n      deleteGroup(id: $id) {\n        success\n        id\n        message\n      }\n    }\n  "])));
  return handleApiResponse(API.graphql(graphqlOperation(mutation, {
    id
  })));
};
export { getGroups, getMembershipGroups, saveGroupApiRequest, deleteGroupApiRequest };